import { RuleClubDTO, RuleGroup } from "@gymflow/types";
import { QueryKey, queryOptions } from "@tanstack/react-query";

import { api } from "../../api";

const keys = {
  all: () => ["hostedApiRules"] as QueryKey,
  list: () => [...keys.all(), "list"] as QueryKey,
  appointableRules: (id: unknown) =>
    [...keys.all(), "appointableRules", id] as QueryKey,
  membershipRules: (id: unknown) =>
    [...keys.all(), "membershipRules", id] as QueryKey,
  activityRules: (id: unknown) =>
    [...keys.all(), "activityRules", id] as QueryKey,
};

export const hostedApiRules = {
  keys,
  queries: {
    list: () =>
      queryOptions({
        queryKey: keys.list(),
        queryFn: async () => {
          return (await api.get<RuleClubDTO[]>("/hosted/rules")).data;
        },
      }),
    appointableRules: (id: number | undefined) =>
      queryOptions({
        queryKey: keys.appointableRules(id),
        queryFn: async () => {
          return (
            await api.get<RuleGroup>(`/hosted/rule-group?appointableId=${id}`)
          ).data;
        },
        enabled: !!id,
      }),
    membershipRules: (id: number | undefined) =>
      queryOptions({
        queryKey: keys.membershipRules(id),
        queryFn: async () => {
          return (
            await api.get<RuleGroup>(`/hosted/rule-group?membershipId=${id}`)
          ).data;
        },
        enabled: !!id,
      }),
    activityRules: (id: number | undefined) =>
      queryOptions({
        queryKey: keys.activityRules(id),
        queryFn: async () => {
          return (
            await api.get<RuleGroup>(`/hosted/rule-group?activityId=${id}`)
          ).data;
        },
        enabled: !!id,
      }),
  },
  infiniteQueries: {},
  mutations: {},
};
